import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Language } from '@anytag/shared-types';
import { cn } from '@anytag/shared-utils';

declare const IS_DISABLED_ON_PROD: boolean;

export const CrowdinButton = ({ open = false, className }: { open?: boolean; className?: string }) => {
  const { i18n } = useTranslation();

  const injectCrowdin = useCallback(() => {
    if (window._jipt) {
      return;
    } else {
      window._jipt = [['project', 'anytag_admin']];

      const crowdinWidget = document.createElement('script');
      crowdinWidget.src = '//cdn.crowdin.com/jipt/jipt.js';
      crowdinWidget.type = 'text/javascript';
      crowdinWidget.async = true;

      document.getElementsByTagName('body')[0]?.appendChild(crowdinWidget);
      i18n.changeLanguage(Language['en-JA']);
    }
  }, [i18n.language]);

  return !IS_DISABLED_ON_PROD ? (
    <button
      onClick={injectCrowdin}
      className={cn(
        'm-1 box-border cursor-pointer rounded-sm px-3 py-2 text-left text-sm font-medium hover:text-active hover:shadow',
        className
      )}
    >
      <span className="truncate">Translate</span>
    </button>
  ) : null;
};
